var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.066 4.483h-.917v-.65a.5.5 0 00-1 0v.65H8.474v-.65a.5.5 0 10-1 0v.65h-.741a2.092 2.092 0 00-2.1 2.084V14.9a1.916 1.916 0 001.916 1.917h8.517a1.925 1.925 0 001.925-1.917V6.392a1.925 1.925 0 00-1.925-1.909zm.925 10.442a.925.925 0 01-.925.908H6.55a.917.917 0 01-.916-.916V7.958h9.1a.5.5 0 000-1h-9.1v-.391a1.092 1.092 0 011.1-1.092h.75v.408a.5.5 0 001 0v-.408h4.683v.408a.5.5 0 001 0v-.408h.9a.925.925 0 01.925.917v8.533z",
    fill: "#0DD1C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.504 11.372a.417.417 0 000 .59l1.667 1.666a.417.417 0 00.59-.59l-.956-.955h3.16a.417.417 0 000-.833h-3.16l.955-.955a.417.417 0 00-.589-.59l-1.667 1.667z",
    fill: "#0DD1C5"
  })));
}
export default SvgCalendarBack;